export default "__VITE_ASSET__C3HJFZX2__"